import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/outline';
import './Pagination.scss';
import ReactPaginate from "react-paginate";

const Pagination = (props: any) => {
  const { setPage, paging, setFilter, flex } = props;

  const handlePageClick = (e: any) => {
    setPage(e.selected + 1);

    if (setFilter) {
      setFilter(true);
    }
  }

  return (
    <div id="pagination" className={(flex && flex === 'end') ? 'justify-end' : 'justify-center'}>
      <ReactPaginate
        breakLabel="..."
        nextLabel={<ChevronRightIcon className="icon-next-page" />}
        className="paging"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={paging.total_page}
        activeClassName="active"
        previousLabel={<ChevronLeftIcon className="icon-next-page" />}
        forcePage={paging.current_page - 1}
      />

    </div>
  )
}

export default Pagination;